export default __webpack_public_path__ + "static/media/logo-light.aadd9281.png";